"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdaptersByReadyState = getAdaptersByReadyState;
exports.sortWalletAdapters = sortWalletAdapters;
var wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
var environment_1 = require("./environment");
/**
 * Get wallet adapters by ready state
 * @param adapters Array of adapters
 * @param readyState The ready state to filter by
 * @returns Filtered array of adapters
 */
function getAdaptersByReadyState(adapters, readyState) {
    return adapters.filter(function (adapter) { return adapter.readyState === readyState; });
}
/**
 * Sort wallet adapters by priority (Mobile > Installed > Loadable > others)
 * @param adapters Array of wallet adapters
 * @returns Sorted array of wallet adapters
 */
function sortWalletAdapters(adapters) {
    // Create a copy of the array to avoid mutating the original
    var sortedAdapters = __spreadArray([], adapters, true);
    // Sort the adapters by ready state priority
    return sortedAdapters.sort(function (a, b) {
        // Mobile wallet adapter gets top priority on mobile
        if (a.name === environment_1.SolanaMobileWalletAdapterWalletName)
            return -1;
        if (b.name === environment_1.SolanaMobileWalletAdapterWalletName)
            return 1;
        // Then installed wallets
        if (a.readyState === wallet_adapter_base_1.WalletReadyState.Installed && b.readyState !== wallet_adapter_base_1.WalletReadyState.Installed) {
            return -1;
        }
        if (a.readyState !== wallet_adapter_base_1.WalletReadyState.Installed && b.readyState === wallet_adapter_base_1.WalletReadyState.Installed) {
            return 1;
        }
        // Then loadable wallets
        if (a.readyState === wallet_adapter_base_1.WalletReadyState.Loadable && b.readyState !== wallet_adapter_base_1.WalletReadyState.Loadable) {
            return -1;
        }
        if (a.readyState !== wallet_adapter_base_1.WalletReadyState.Loadable && b.readyState === wallet_adapter_base_1.WalletReadyState.Loadable) {
            return 1;
        }
        return 0;
    });
}
